import React from 'react'
import { Carousel, Col, Container, Row } from 'react-bootstrap'
import DownloadApp from '../DownloadApp'
import pdfUrl from '../../resourses/Manual-de-granos.pdf'
import img1 from '../../resourses/DSC01198.webp'
import img2 from '../../resourses/DSC01275.webp'
import img3 from '../../resourses/GUALTIERI-33.webp'

const HomeContent4 = props => {

  //const isDesktop = props.width >= 300

    return (
        <div>
            <Container>
                
                <Row className="mt-5 tranquilidad-row">
                    <Col lg={6} className="tranqui-carousel-col">
                    
                            <Carousel
                                controls={false}
                                indicators={true}
                                interval={4000}
                                fade
                                className="tranqui-carousel-bg"
                            >
                                <Carousel.Item>
                                    <img src={img1} className="tranqui-carousel-img" alt="Gualtieri e Hijos" />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={img2} className="tranqui-carousel-img" alt="Gualtieri e Hijos" />
                                </Carousel.Item>
                                <Carousel.Item>
                                    <img src={img3} className="tranqui-carousel-img" alt="Gualtieri e Hijos" />
                                </Carousel.Item>
                            </Carousel>
                      
                    </Col>
                    <Col lg={6} className="p-5 d-flex flex-column tranquilidad-col">
                        <h2 className="tranqui-title pl-5 pr-4 white">Elegí eficacia y tranquilidad</h2>
                        <h4 className="greenblue mt-2">Entregas ágiles y sin sorpresas</h4>
                        <h5 className="greenblue mt-2">El tiempo es valioso: cada operación llega a destino en los plazos acordados
</h5>
                       <div className="d-flex buttons-container">
                            <button
                                onClick={() => window.open(pdfUrl, '_blank')}
                                className="btn green-btn btn-light mt-3"
                            >
                                {">"} Ver manual de granos
                            </button>

                            <button
                                onClick={() => window.open("https://www.instagram.com/gualtieriehijos/", '_blank')}
                                className="btn btn-light mx-2 mt-3"
                            >
                                {">"} Conocé más
                            </button>
                    </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default HomeContent4